import { render } from "./Dispatch.vue?vue&type=template&id=17b5cf45&scoped=true"
import script from "./Dispatch.vue?vue&type=script&lang=js"
export * from "./Dispatch.vue?vue&type=script&lang=js"

import "./Dispatch.vue?vue&type=style&index=0&id=17b5cf45&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3012/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17b5cf45"]])

export default __exports__